module.exports = __webpack_public_path__ + "static/media/sfx.430e2c80.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/sfx.wav
// module id = 29
// module chunks = 0